import m from 'mithril'

export default {
  view: vnode => {
    const notebook = require('./notebook2.png')

    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-15-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
         <h3 className="log-book-text mod-h3">Umanak</h3>
          <p className="log-book-text">Umanak er Thuleboernes eget navn for Thule-området. Det betyder ‘Det hjerteformede fjeld’.</p>
          <figure className="log-book-figure">
            <img src={notebook} className="log-book-img" />
            <figcaption className="log-book-figcaption">
            Da Thuleboerne ankom til Kanak, var de huse, de var blevet lovet, endnu ikke bygget. Derfor boede de i telte. 
            </figcaption>
          </figure>
          
          <h3 className="log-book-text mod-h3">Billige huse</h3>

          <ul><li><p className="log-book-text">Beløb brugt på opførelsen af Thulebasen 1.000.000.000 $.</p></li>
          <li><p className="log-book-text">Beløb brugt til genhusning af de forflyttede: 100.000 $.</p></li></ul>
          
          
        </div>
      </div>
    )
  }
}
